import { z } from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export const schema = z.object({
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  consumed: z.boolean(),
  organizationId: z.string(),
  sectionId: nullSafeOptionalString(),
  sectionPassCouponFolderId: z.string(),
  sectionPassCouponId: z.string(),
  userId: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    updatedAt: null,
    consumed: false,
    organizationId: '',
    sectionPassCouponFolderId: '',
    sectionPassCouponId: '',
  })
)

export type FirestoreOrganizationSectionPassCoupon = z.infer<typeof schema>
